
import ProfileDisplaySetting from '@/views/settings/components/settings/ProfileDisplaySetting.vue';
import { defineComponent } from 'vue';

export default defineComponent({
  name: 'SectionProfileSettings',
  components: {
    ProfileDisplaySetting
  }
});
